<template>
    <div class="emoji-vue-wraper" v-bind:id="id">
        <div class="emoji-picker-container">
            <textarea v-model="value" data-vue-emojiable="true" class="emoji-vue-textarea"></textarea>
            <p class="placeholder" v-show="placeholderShow">{{placeholder}}</p>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import './lib/css/emoji.css';

  import storageUtils from './lib/js/util';
  import {EmojiPicker} from './lib/js/emoji-picker';
  import {getGuid} from './lib/js/jquery.emojiarea';

  import './lib/img/IconsetSmiles.png';
  import './lib/img/IconsetSmiles_1x.png';
  import './lib/img/IconsetW.png';
  import './lib/img/IconsetW_1x.png';

  export default {
    name: 'Emoji',
    data() {
      return {
        id: getGuid(),
        editor: null,
        placeholderShow: true
      };
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      clearContent: {
        type: Boolean,
        default: false
      },
      focus: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    watch: {
      clearContent(val) {
        if (val) {
          this.editor.innerHTML = '';
          this.$emit('clear');
        }
      },
      value(val) {
        if (this.editor.innerHTML !== val) {
          this.editor.innerHTML = val;
          this.editor.focus();
        }
      },
      focus(val) {
        if (val) {
          this.editor.focus();
        }
      }
    },
    methods: {
      initEmojiPlugin() {
        window.emojiPicker = new EmojiPicker({
          emojiable_selector: `[data-vue-emojiable=true]`,//#${this.id}
          assetsPath: '',
          popupButtonClasses: 'smile-icon',
          onChange: (textAreaValue) => {
            this.$emit('input', this.editor.innerHTML);
            this.$emit('change', this.editor.innerHTML);
            // this.$emit('input', textAreaValue);
            this.placeholderShow = !this.editor.innerHTML.length > 0;
            // console.log(this.editor.innerHTML);
          }
        });
        window.emojiPicker.discover();
        this.$nextTick(() => {
          this.editor = this.$el.querySelector('.emoji-wysiwyg-editor');
          this.editor.innerHTML = this.value;
          // console.log(this.editor)
        });
      }
    },
    mounted() {
      this.$nextTick(() => {
        storageUtils();
        this.initEmojiPlugin();
      });
    }
  };
</script>

<style lang="less">
    .placeholder {
        position: absolute;
        top: 7px;
        left: 12px;
        line-height: 25px;
        font-size: 16px;
        color: #ccc;
    }

    .emoji-picker-container {
        /*padding-bottom: 6px;*/
        background-color: #f4f8fb
    }

    .emoji-vue-wraper {
        min-height: 48px;
        padding-top: 6px;
        background-color: #f4f8fb;
        .emoji-wysiwyg-editor {
            margin-left: 5px;
            margin-right: 110px;
            line-height: 25px;;
            padding: 5px;
            background-color: white;
            height: auto;
            font-size: 16px;
        }
        .emoji-menu {
            width: 100%;
            position: initial;
            margin-top: 6px;
            border-radius: 0;
            .emoji-items-wrap {
                height: 134px;
                overflow-y: scroll;
            }
        }
        i.emoji-picker-icon.emoji-picker {
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAB+ElEQVRYhe2WPS8EURSGHxQkFOIrNHaRbFT8BDWdwkfYWk2Cf+CnIAoJkRAdtXJVW4hkKZesECJ2RzHvNbOzd3bvjO14k5vZnI/3nHPv2XsP/OOvoyOh/RSwAswBM0C/5M9AAbgCjoC7NuX3gyxwCFQBr8WqAgdApl3B88CLyD+BY8mmgV6tacmOZePJZ/23wXeBmghPgJyDT062nnx30gbPi6CqRJJiV741UuxEhmDbU1egJDzgFb+BnXFIsO0GC8CD1rzFJ05/Kq4D1+BT+Fv3Sf2ZPxB0esniF6fPiesLmIg6dVqIViQ/A4ohudci8Th9UVxd4m6JS5HlI/J5/MpK2I+gmT4vzguXBB5l7PKXc0WO+KNrwIeM+9qYQJ8436MKWw+Ys0z6TjSDidPQJ7YEnvQdi8hngY0YnzDfhmzDGNW33DRNIa4JzyVfauK7LJvziDy2CW3VXOu7aEkMYA8YtviNSIclkOG6svg1YBL7RdQD3OJXUsSvdhAY0u+idAWgO+QXvoiyLgmA/SoG/40wSdhWARiP+CS+ik0g8xhFX8IeYAu4Ad60boBN6iuH4DGqkGJAWad9z/FaCn/Af4rNQHKK+0Bitr0GbKcNbpB2JKvwi8qjyOA3kctQ+gXs43jmSa/bLLBKMJYPSF6mfiy/T8j7jz+Mb+FSr4ihuoIZAAAAAElFTkSuQmCC') no-repeat center center;
            width: 24px;
            height: 24px;
            opacity: 0.5;
            cursor: pointer;
            right: 77px;
            top: 7px;
        }
    }

</style>
